// extracted by mini-css-extract-plugin
export var header = "contact-module--header--6WuCw";
export var cardContainer = "contact-module--cardContainer--p1EhJ";
export var card = "contact-module--card--PQTME";
export var info = "contact-module--info--5Co08";